<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center mb-4">
    <h2 class="text-left h3-tipografia-govco mb-0">
      {{ 'gestion-entidades.titulo' | translate }}
    </h2>
  </div>
  <div id="entidades">
    <div
      class="accordion-govco my-3"
      [id]="'faqAccordion' + entidad.Entidad"
      *ngFor="let entidad of entidades; let i = index">
      <div class="accordion-item">
        <h3 class="h4-tipografia-govco" [attr.id]="'heading' + i">
          <button
            class="button-accordion-govco"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + i"
            aria-expanded="false"
            [attr.aria-controls]="'collapse' + i"
            [attr.aria-label]="'Ver información'">
            <img
              [src]="entidad.Logo || '../../../../assets/img/H-DIMAR.png'"
              alt="{{ entidad.Entidad }} logo"
              width="40"
              height="40"
              class="logo-icon" />
            <p class="text2-govco mb-0">
              {{ entidad.Entidad }}
            </p>
          </button>
        </h3>
        <div
          [attr.id]="'collapse' + i"
          class="accordion-collapse collapse"
          [attr.aria-labelledby]="'heading' + i"
          [attr.data-bs-parent]="'#faqAccordion' + entidad.Entidad">
          <div
            class="body-accordion-govco"
            *ngFor="let tramite of entidad.Tipo_Tramite">
            <label
              class="label-input-tramite"
              [ngClass]="{
                'disabled-form': !tramite.Entidad.Estado,
              }">
              {{ tramite.Nombre_Completo }}
              <input
                type="checkbox"
                [checked]="tramite.Estado"
                [disabled]="
                  selectedTramiteId !== null && selectedTramiteId !== tramite.Id
                "
                (change)="toggleSelection(tramite)" />
            </label>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn-govco fill-btn-govco"
      [disabled]="selectedTramiteId === null"
      (click)="toggleForms()"
      aria-label="Toggle forms">
      {{
        !disableMode
          ? ('gestion-entidades.deshabilitar' | translate)
          : ('gestion-entidades.habilitar' | translate)
      }}
    </button>
  </div>
</div>
